var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('a',{staticClass:"in-dm-card-button",attrs:{"href":_setup.safeUrl || undefined,"target":"_blank","rel":"noopener noreferrer"}},[_vm._v("\n  "+_vm._s(_vm.name)+"\n")])
}
var staticRenderFns = []

export { render, staticRenderFns }